import React from 'react';

export const ActionHints: React.FC = () => {
  return (
    <div className="mt-4 text-sm text-text-secondary">
      <p>
        <strong>Hinweise:</strong>
      </p>
      <ul className="list-disc list-inside space-y-1 mt-2">
        <li>
          <strong>Sperren & Bearbeiten:</strong> Sperrt den Vorgang für andere
          Benutzer und ermöglicht die Bearbeitung
        </li>
        <li>
          <strong>Erneut verarbeiten:</strong> Sendet die korrigierten Daten zur
          erneuten Verarbeitung durch das System. Bei Auswahl eines früheren
          Abarbeitungsschrittes wird eine neue Abarbeitung von diesem Schritt
          gestartet.
        </li>
        <li>
          <strong>Zurückstellen</strong> Setzt den Vorgang so zurück, dass er
          erst wieder nach manueller Nachbearbeitung (Retry, Fehlerkorrektur)
          erneut angestoßen wird oder bis der Vorgang gelöscht wurde.
        </li>
        <li>
          <strong>Speichern:</strong> Speichert die Änderungen ohne erneute
          Verarbeitung
        </li>
        <li>
          <strong>Löschen:</strong> Entfernt den Vorgang permanent aus der
          Korrekturliste. Das Löschen ist für Vorgänge im Status, 'Laufend' &
          'Erledigt' nicht möglich.
        </li>
        <li>
          <strong>Entsperren:</strong> Gibt den Vorgang für andere Benutzer frei
        </li>
        <li>
          <strong>Wiederherstellen:</strong> Stellt den Vorgang wieder her, wenn
          er gelöscht wurde
        </li>
      </ul>
    </div>
  );
};
